import React from "react";
import {ReactComponent as SancorLogo} from "../../../assets/images/Sancor.svg";

import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    sancorDiv: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        clipPath: "polygon(0 0, 40% 0, 60% 100%, 0 100%)",
        width: "100%",
        position: "relative",
        [theme.breakpoints.up('xl')]: {
            height: "240px",
        },
        [theme.breakpoints.down('xl')]: {
            height: "192px",
        },
        [theme.breakpoints.down('lg')]: {
            height: "160px",
        },
        [theme.breakpoints.down('md')]: {
            height: "120px",
        },
        [theme.breakpoints.down('sm')]: {
            height: "104px",
        },
    },
    affinityDiv: {
        backgroundColor: "#004285",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        clipPath: "polygon(40% 0, 100% 0, 100% 100%, 60% 100%)",
        alignItems: "self-end",
        position: "absolute",
        top: "0%",
        left: "-1%",
        width: "101%",
        [theme.breakpoints.up('xl')]: {
            height: "240px",
        },
        [theme.breakpoints.down('xl')]: {
            height: "192px",
        },
        [theme.breakpoints.down('lg')]: {
            height: "160px",
        },
        [theme.breakpoints.down('md')]: {
            height: "120px",
        },
        [theme.breakpoints.down('sm')]: {
            height: "104px",
        },
    },
    sancorImg: {
        marginRight: "auto",
        display: "block",
        marginLeft: "10%",
        width: "176px",
        height: "auto"
    },
    affinityImg: {
        display: "block",
        width: "160px",
        height: "auto",
        marginRight: "10%"
    }
}));

const Header = (props) => {
    const classes = useStyles();
    return (
        <React.Fragment>
            <div className={classes.sancorDiv}>
                <SancorLogo className={classes.sancorImg}/>
            </div>
            <div className={classes.affinityDiv}>
                <img src={props.affinityPicture} className={classes.affinityImg}/>
            </div>
        </React.Fragment>
    );
};

export default Header;
